import { Controller } from "@hotwired/stimulus"
import {
  ROAM_DURATION_MS,
  easeInOut,
  pointAlongWaypoints,
  roamWaypoints,
  shouldRoam
} from "../lair/warren_roam.js"

// The warren overview: when the dragon has changed chambers since the last
// visit, its mark walks the passage instead of teleporting. rAF on cx/cy —
// never CSS transform against SVG positioning (the transform trap).
export default class extends Controller {
  static values = {
    dragonRoom: Number,
    chambers: Array,
    storageKey: { type: String, default: "lairlings:warren-dragon:own" }
  }

  connect() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.staticMark = this.element.querySelector(".ll-warren-actor--dragon:not(.ll-warren-actor--roaming)")
    if (!this.staticMark) return

    const storage = this.storage()
    const lastRaw = storage.getItem(this.storageKeyValue)
    const lastRoom = lastRaw === null ? null : parseInt(lastRaw, 10)
    const dragonRoom = this.dragonRoomValue

    storage.setItem(this.storageKeyValue, String(dragonRoom))

    if (!shouldRoam(lastRoom, dragonRoom, this.reducedMotion)) return

    const waypoints = roamWaypoints(this.chambersValue, lastRoom, dragonRoom)
    this.staticMark.style.visibility = "hidden"

    const roam = this.staticMark.cloneNode(true)
    roam.classList.add("ll-warren-actor--roaming")
    roam.removeAttribute("style")
    this.element.appendChild(roam)

    const start = performance.now()
    const tick = (now) => {
      const raw = Math.min(1, (now - start) / ROAM_DURATION_MS)
      const pos = pointAlongWaypoints(waypoints, easeInOut(raw))
      roam.setAttribute("cx", pos.x.toFixed(1))
      roam.setAttribute("cy", pos.y.toFixed(1))

      if (raw < 1) {
        this.frame = requestAnimationFrame(tick)
      } else {
        this.staticMark.style.visibility = ""
        roam.remove()
      }
    }

    const anchor = waypoints[0]
    roam.setAttribute("cx", anchor.x.toFixed(1))
    roam.setAttribute("cy", anchor.y.toFixed(1))
    this.frame = requestAnimationFrame(tick)
  }

  disconnect() {
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  storage() {
    try {
      return window.localStorage
    } catch {
      return { getItem: () => null, setItem: () => {} }
    }
  }
}
